/*长春历史数据*/

const ccPolicyApplyPage = () => import('../modules/cchistory/ccpolicyapply/PageList.vue')
const ccCreditAndLoadInfoPage = () => import('../modules/cchistory/cccreditandloadinfo/PageList.vue')
const financeLeasePage = () => import('../modules/cchistory/cccreditandloadinfo/PageList_financeLease.vue')
const ccCounterGuaranteePage = () => import('../modules/cchistory/cccounterguarantee/PageList.vue')
const ccOtherBusinessInfoPage = () => import('../modules/cchistory/ccotherbusinessinfo/PageList.vue')
const ccFundBusinessInfoPage = () => import('../modules/cchistory/ccfundbusinessinfo/PageList.vue')
const ccOrderPage = () => import('../modules/cchistory/ccorder/PageList.vue')

export default [
  {
    path: '/ccPolicyApplyPage',
    name: 'ccpolicyapply',
    component: ccPolicyApplyPage,
    meta: {
      title: '政策申报管理',
    },
  },
  {
    path: '/ccCreditAndLoadInfoPage',
    name: 'cccreditandloadinfo',
    component: ccCreditAndLoadInfoPage,
    meta: {
      title: '银行业务明细查询',
    },
  },
  {
    path: '/financeLeasePage',
    name: 'financeLease',
    component: financeLeasePage,
    meta: {
      title: '金租业务明细查询',
    },
  },
  {
    path: '/ccCounterGuaranteePage',
    name: 'cccounterguaranteepage',
    component: ccCounterGuaranteePage,
    meta: {
      title: '反担保方式业务明细',
    },
  },
  {
    path: '/ccOtherBusinessInfoPage',
    name: 'ccotherbusinessinfopage',
    component: ccOtherBusinessInfoPage,
    meta: {
      title: '其他业务明细查询',
    },
  },
  {
    path: '/ccFundBusinessInfoPage',
    name: 'ccfundbusinessinfopage',
    component: ccFundBusinessInfoPage,
    meta: {
      title: '基金业务明细查询',
    },
  },
  {
    path: '/ccOrderPage',
    name: 'ccorderpage',
    component: ccOrderPage,
    meta: {
      title: '撮合需求列表',
    },
  },

]
